var _defs, _path, _path2, _line, _polyline, _path3, _path4, _line2, _polyline2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsFreshSalads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.88,54.75c0,18.29-10.42,34.14-24.5,41.99v5.25c0,.97-.78,1.75-1.75,1.75H41.63c-.97,0-1.75-.78-1.75-1.75v-5.25c-14.08-7.85-24.5-23.7-24.5-41.99H102.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,87.57c-8.53-4.75-14.84-12.97-17.59-22.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.88,
    y1: 96.74,
    x2: 78.38,
    y2: 96.74
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "74.88 39 74.88 47.75 85.38 37.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.54,47.75c2.13-6.08,2.88-13.04,1.93-20.59-19.18-2.41-34.55,6.06-41.33,20.59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.41,39.6c-4.02-10.48-13.09-19.06-26.37-23.34-6.66,10.6-8.5,21.67-6.18,31.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.91,
    y1: 29.67,
    x2: 44.5,
    y2: 47.75
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.64 39 42.99 43.62 46.69 35.69"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsFreshSalads);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_FreshSalads.cf892703115f46428fcf4a6c51246159.svg";
export { ForwardRef as ReactComponent };